const apiUrl: string = process.env.VUE_APP_API;

class URL {
  public base: string;
  public url: string;

  constructor(base: string) {
    this.base = base;
    this.url = '';
  }

  path(path: any, args?: any): string {
    path = path.split('.');

    let obj: any = this;
    let url: string = this.base;

    for (let i = 0; i < path.length && obj; i++) {
      if (obj.url) {
        url += '/' + obj.url;
      }

      obj = obj[path[i]]; // TODO: fix typescript errs
    }

    if (obj) {
      url = url + '/' + (typeof obj === 'string' ? obj : obj.url);
    }

    if (args) {
      for (let key in args) {
        url = url.replace(':' + key, args[key]);
      }
    }

    return url;
  }
}

export const api = Object.assign(new URL(apiUrl), {
  url: '',

  v2: {
    url: 'v2',
    admin: {
      url: 'admin',

      cities: {
        url: 'cities',
        single: ':id',
      },

      notifications: {
        url: 'notifications',
        single: ':id',
      },

      transactionSubtypes: {
        url: 'transaction-subtypes',
        single: ':id',
      },
    },

    cities: {
      url: 'cities',
    },
  },
  v1: {
    url: 'v1',

    login: {
      url: 'login',
      refresh: 'refresh',
    },

    logout: 'logout',

    password: {
      url: 'password',
      forgot: 'forgot',
      reset: 'reset',
    },

    me: {
      url: 'me',
    },

    profile: {
      url: 'profile',
      locale: {
        url: 'locale',
      },
    },

    b: {
      url: 'b',

      profile: {
        url: 'profile',
        edit: {
          url: 'edit',
        },
      },

      sessions: {
        url: 'sessions',
      },

      familyReports: {
        url: 'family-reports',
        single: ':id',
      },

      documents: {
        url: 'documents',

        avatar: {
          url: 'avatar',
        },

        cv_sr: {
          url: 'cv-sr',
        },

        cv_en: {
          url: 'cv-en',
        },

        id_card: {
          url: 'id-card',
        },

        court_cert: {
          url: 'court-cert',
        },

        police_cert: {
          url: 'police-cert',
        },

        first_aid_cert: {
          url: 'first-aid-cert',
        },
      },
    },

    p: {
      url: 'p',

      profile: {
        url: 'profile',
        edit: {
          url: 'edit',
        },

        updateChildren: {
          url: 'update-children',
        },
        updateParents: {
          url: 'update-parents',
        },
        babysittingPreferences: {
          url: 'babysitting-preferences',
        },
      },

      sessions: {
        url: 'sessions',
      },

      babysitterReports: {
        url: 'babysitter-reports',
        single: ':id',
      },
    },

    experiences: {
      url: 'experiences',
    },

    languages: {
      url: 'languages',
    },

    nationalities: {
      url: 'nationalities',
    },

    pets: {
      url: 'pets',
    },

    admin: {
      url: 'admin',

      sessions: {
        url: 'sessions',
        single: ':id',
        invite: {
          url: ':id/invite',
        },

        cancel: {
          url: ':id/cancel',
        },

        cancelFamily: {
          url: ':id/cancel-family',
        },

        cancelBabysitter: {
          url: ':id/cancel-babysitter',
        },

        confirm: {
          url: ':id/confirm',
        },

        report: {
          url: ':id/report',
        },

        review: {
          url: ':id/review',
        },
      },

      sessionReports: {
        url: 'session-reports',
      },

      sessionTypes: {
        url: 'session-types',
        single: ':id',
      },

      roles: {
        url: 'roles',
        single: ':id',
      },

      users: {
        url: 'users',
        single: ':id',
        reactivate: {
          url: ':id/reactivate',
        },
        deactivate: {
          url: ':id/deactivate',
        },
        promote: {
          url: 'potential/:id/promote',
        },
        potential: {
          url: 'potential/parent',
        },
      },

      families: {
        url: 'families',
        single: ':id/',

        balance: {
          url: ':id/balance',
        },

        edit: {
          url: ':id/edit',
        },

        createTransaction: {
          url: ':id/create-transaction',
        },

        updateChildren: {
          url: ':id/update-children',
        },

        updateParents: {
          url: ':id/update-parents',
        },

        updatePreferredBabysitters: {
          url: ':id/update-babysitters',
        },

        updateBlockedBabysitters: {
          url: ':id/blocked-babysitters',
        },

        updatePets: {
          url: ':id/update-pets',
        },

        babysittingPreferences: {
          url: ':id/babysitting-preferences',
        },
        contactPreferences: {
          url: ':id/contact-preferences',
        },
      },

      familyReports: {
        url: 'family-reports',
        single: ':id',

        toPDF: {
          url: ':id/toPDF',
        },
      },

      babysittersAll: {
        url: 'babysitters-all',
      },

      babysittersBalance: {
        url: 'babysitters-balance',
      },

      babysitters: {
        url: 'babysitters',
        single: ':id',

        edit: {
          url: ':id/edit',
        },

        updateRate: {
          url: ':id/update-rate',
        },

        createTransaction: {
          url: ':id/create-transaction',
        },

        makePayment: {
          url: ':id/make-payment',
        },

        vacations: {
          url: ':id/vacations',
        },

        documents: {
          url: ':id/documents',

          avatar: {
            url: 'avatar',
            single: '/:id',
          },

          cv_sr: {
            url: 'cv-sr',
          },

          cv_en: {
            url: 'cv-en',
          },

          id_card: {
            url: 'id-card',
          },

          court_cert: {
            url: 'court-cert',
          },

          police_cert: {
            url: 'police-cert',
          },

          first_aid_cert: {
            url: 'first-aid-cert',
          },
        },
      },

      babysitterRates: {
        url: 'babysitter-rates',
        single: ':id',
      },

      packages: {
        url: 'packages',
      },

      transactions: {
        url: 'transactions',
      },

      transactionsReport: {
        url: 'transactions-report',
      },

      languages: {
        url: 'languages',
        single: ':id',
      },

      nationalities: {
        url: 'nationalities',
        single: ':id',
      },

      pets: {
        url: 'pets',
        single: ':id',
      },

      experiences: {
        url: 'experiences',
        single: ':id',
      },

      settings: {
        url: 'settings',
      },

      activities: {
        url: 'activities',
      },
      emails: {
        url: 'emails',
      },
      sentEmails: {
        url: 'emails/sent-emails',
      },
      userAgreements: {
        url: 'agreements/user',
      },
      statistics: {
        url: 'statistics',

        families: {
          url: 'families',
          single: ':id',
        },

        babysitters: {
          url: 'babysitters',
          single: ':id',
        },
      },
      password: {
        url: 'password',
        forgot: 'forgot',
        send: 'forgot/send',
      },

      psychTests: {
        url: 'psych-tests',
        identifier: {
          url: 'identifier',
        },
        user: {
          url: 'user/:userId',
        },
      },
    },

    babysitters: {
      url: 'babysitters',
    },

    cv: {
      url: 'cv',
      createIdentifier: {
        url: 'create-identifier',
      },
    },

    sessionSubmit: {
      url: 'sessionSubmit',
    },
  },
});
